<template>
  <div class="Adeletetitle">
    <div class="Adeletetitle_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">职称</div>
      <div class="determine" @click="toInformation">确定</div>
    </div>
    <div class="Adeletetitle_bottm">
      <van-field
        is-link
        readonly
        clickable
        name="picker"
        :value="item.levelOneName"
        label="职称等级"
        placeholder="请选择"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-cell-group style="border-radius: 8px">
        <van-field
          :disabled="item.levelOne === 5"
          v-model="item.levelTwo"
          placeholder="请输入"
          label="职称"
        >
        </van-field>
      </van-cell-group>
    </div>
    <div class="exit">
      <van-button class="bot" @click="show = true">删除</van-button>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text="取消"
        description="确定要删除职称？"
        close-on-click-action
        style="color: #ff3d3d"
        @select="onSelect"
      />
    </div>
  </div>
</template>
    
<script>
import { Toast } from "vant";
export default {
  name: "Adeletetitle",
  data() {
    return {
      disabled: false,
      value: "",
      values: "",
      columns: [],
      columnss: [],
      showPicker: false,
      show: false,
      actions: [{ name: "删除" }],
      item: "",
      itemIndexs: "",
      userInfo: "",
    };
  },
  mounted() {
    this.item = JSON.parse(this.$route.query.item);
    this.itemIndexs = JSON.parse(this.$route.query.indexs);
    this.getTitleList();
  },
  methods: {
    // 选择等级
    async getTitleList() {
      const { data } = await this.$apis.userServe.getTitleList();
      this.columns = data.map((item) => item.titleName);
      this.columnss = data;
    },
    // 修改跳转
    toInformation() {
      if (this.item.levelTwo.length == "" && this.item.levelOne !== 5) {
        Toast("职称不能为空");
      } else {
        this.userInfo = JSON.parse(sessionStorage.getItem("subInfo"));
        this.userInfo.titles[this.itemIndexs] = this.item;
        sessionStorage.setItem("subInfo", JSON.stringify(this.userInfo));
        window.history.go(-1);
      }
    },
    // 确认删除
    onSelect() {
      this.userInfo = JSON.parse(sessionStorage.getItem("subInfo"));
      this.userInfo.titles.splice(this.$route.query.indexs, 1);
      sessionStorage.setItem("subInfo", JSON.stringify(this.userInfo));
      this.$router.push("scholarAuthentication");
    },
    to() {
      window.history.go(-1);
    },
    // 选择等级
    onConfirm(value) {
      this.item.levelOneName = value;
      let arr = this.columnss.filter((item) => item.titleName === value);
      this.item.levelOne = arr[0].titleCode;
      if (this.item.levelOne === 5) this.item.levelTwo = "";
      this.showPicker = false;
    },
  },
};
</script>
    
<style lang="scss" scoped>
.Adeletetitle {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .Adeletetitle_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .Adeletetitle_bottm {
    width: 94%;
    margin: 12px auto;
    background: #fff;
    border-radius: 8px;
  }

  .prompt {
    width: 94%;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin: 0 auto;
  }

  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;

    .bot {
      width: 94%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3d3d;
      background: #ffffff;
      border-radius: 22px;
    }
  }
}
</style>